var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('BinnacleEntriesExtranet',{ref:"binnacle-timeline",attrs:{"entries":_vm.binnacleEntries,"submitting":_vm.submitting,"taggableUsers":_vm.taggableUsers,"show-new-comment-input":_vm.$canView('Sinister', 'binnacle'),"add-new-comment-input":_vm.$canAdd('Sinister', 'binnacle')},on:{"update:newComment":_vm.addComment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/RoadSinisters/File/Binnacle.vue